// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-container {
  display: flex;
  margin: auto;
  width: 50%;
  text-align: center;
}
@media screen and (max-width: 568px) {
  .tab-container {
    width: 60%;
  }
}
.tab-container .tab-style {
  flex: 1;
  font-family: var(--font-secondary);
  font-style: normal;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: var(--ion-color-secondary);
  cursor: pointer;
}
@media screen and (max-width: 568px) {
  .tab-container .tab-style {
    font-size: 11px;
  }
}
.tab-container .selected {
  text-decoration: underline;
  color: rgb(19, 133, 191);
  text-underline-offset: 5px;
  text-decoration-thickness: 3px;
}

.spinner-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  color: var(--ion-color-secondary);
}
.spinner-container span {
  font-weight: 500;
  font-size: 12px;
}
.spinner-container ion-spinner {
  color: var(--ion-color-secondary);
  margin: 10% auto auto auto;
}

ion-row {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: both;
}

.iframe-support::ng-deep ion-grid {
  margin: 0px;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/points-conversion/points-conversion.page.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AACJ;AACI;EANJ;IAOQ,UAAA;EAEN;AACF;AAAI;EACI,OAAA;EACA,kCAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;AAER;AAAQ;EAXJ;IAYQ,eAAA;EAGV;AACF;AAAI;EACI,0BAAA;EACA,wBAAA;EACA,0BAAA;EACA,8BAAA;AAER;;AAGA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iCAAA;AAAJ;AAEI;EACI,gBAAA;EACA,eAAA;AAAR;AAGI;EACI,iCAAA;EACA,0BAAA;AADR;;AAKA;EAEI,sBAAA;EAEA,sBAAA;EAEA,yBAAA;AAFJ;;AAOQ;EACI,WAAA;AAJZ;AAmBA;EACI;IACI,UAAA;EARN;EAWE;IACI,UAAA;EATN;AACF","sourcesContent":[".tab-container {\n    display: flex;\n    margin: auto;\n    width: 50%;\n    text-align: center;\n\n    @media screen and (max-width: 568px) {\n        width: 60%;\n    }\n\n    .tab-style {\n        flex: 1;\n        font-family: var(--font-secondary);\n        font-style: normal;\n        text-transform: uppercase;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 24px;\n        color: var(--ion-color-secondary);\n        cursor: pointer;\n\n        @media screen and (max-width: 568px) {\n            font-size: 11px;\n        }\n    }\n\n    .selected {\n        text-decoration: underline;\n        color: rgba(19, 133, 191, 1);\n        text-underline-offset: 5px;\n        text-decoration-thickness: 3px;\n    }\n}\n\n\n.spinner-container {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n    color: var(--ion-color-secondary);\n\n    span {\n        font-weight: 500;\n        font-size: 12px;\n    }\n\n    ion-spinner {\n        color: var(--ion-color-secondary);\n        margin: 10% auto auto auto;\n    }\n}\n\nion-row {\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n.iframe-support {\n    &::ng-deep {\n        ion-grid {\n            margin: 0px;\n        }\n    }\n}\n\n@-webkit-keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
